import { schema } from 'normalizr';

export const userSchema = new schema.Entity('users');
export const userListSchema = [ userSchema ];



// WEBPACK FOOTER //
// ./src/schemas/user.js